import { motion } from "framer-motion";
import MaskedLines, { EASE } from "./MaskedLines";

export default function PageHeader({ crumb, eyebrow, lines, sub }) {
    return (
        <header className="px-5 lg:px-12 xl:px-16 pt-28 lg:pt-32 pb-12 lg:pb-16 border-b border-line">
            <div className="flex items-center justify-between mono text-[10px] tracking-[0.25em] text-muted2">
                <motion.span
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.1 }}
                    data-testid="page-crumb"
                >
                    {crumb}
                </motion.span>
                <motion.span
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.2 }}
                    className="hidden md:block"
                >
                    IDEAS → ACTION → IMPACT
                </motion.span>
            </div>
            {eyebrow && (
                <motion.p
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.25, duration: 0.6, ease: EASE }}
                    className="mono text-xs tracking-[0.3em] text-muted2 mt-10"
                >
                    {eyebrow}
                </motion.p>
            )}
            <MaskedLines
                lines={lines}
                className="font-display leading-[0.9] tracking-tight text-[clamp(2.8rem,7.5vw,6.5rem)] mt-3 block"
                delay={0.3}
            />
            {sub && (
                <motion.p
                    initial={{ opacity: 0, y: 12 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.7, duration: 0.7, ease: EASE }}
                    className="serif-it text-xl md:text-2xl text-muted2 mt-6"
                >
                    {sub}
                </motion.p>
            )}
        </header>
    );
}
